export default __webpack_public_path__ + "93a49c0dffcf0ae93019adc539a36a85.png";